var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 13,
    viewBox: "0 0 12 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3_823)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.94 11.69C6.93167 11.6758 7.83833 11.435 8.66 10.9675C9.48167 10.4858 10.1475 9.82 10.6575 8.97C11.1392 8.10584 11.38 7.19917 11.38 6.25C11.38 5.30084 11.1392 4.39417 10.6575 3.53C10.1475 2.68 9.48167 2.01417 8.66 1.5325C7.83833 1.065 6.93167 0.824169 5.94 0.810002C4.94833 0.824169 4.04167 1.065 3.22 1.5325C2.39833 2.01417 1.7325 2.68 1.2225 3.53C0.740833 4.39417 0.5 5.30084 0.5 6.25C0.5 7.19917 0.740833 8.10584 1.2225 8.97C1.7325 9.82 2.39833 10.4858 3.22 10.9675C4.04167 11.435 4.94833 11.6758 5.94 11.69ZM8.34125 5.25125L5.62125 7.97125C5.38042 8.16959 5.13958 8.16959 4.89875 7.97125L3.53875 6.61125C3.34042 6.37042 3.34042 6.12959 3.53875 5.88875C3.77958 5.69042 4.02042 5.69042 4.26125 5.88875L5.26 6.8875L7.61875 4.52875C7.85958 4.33042 8.10042 4.33042 8.34125 4.52875C8.53958 4.76959 8.53958 5.01042 8.34125 5.25125Z",
    fill: "#00A186"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3_823"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 10.88,
    height: 12,
    fill: "white",
    transform: "matrix(1 0 0 -1 0.5 12.25)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheck);
export default __webpack_public_path__ + "static/media/check.c21f31e7b1baef4cea1d6929584809c3.svg";
export { ForwardRef as ReactComponent };